// extracted by mini-css-extract-plugin
export default {"serviceCardWrapper":"ContactPage_serviceCardWrapper__PNWwv","swingUpDown":"ContactPage_swingUpDown__U+WUM"};